import type { ReactNode } from 'react';
import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components/typography/typography';
import Icon from 'components/icon/icon';

interface TooltipProps {
  children?: ReactNode;
  position?: 'top' | 'bottom' | 'right' | 'left';
  content: string;
  className?: string;
  typographyClassName?: string;
  iconClassName?: string;
  tooltipClasssName?: string;
}

const Tooltip: React.FC<TooltipProps> = (props) => {
  const { content, children, position } = props;

  const parentClassNames = twMerge(
    'relative flex  group justify-center items-center',
    position === 'bottom' && 'flex-col',
    position === 'top' && 'flex-col-reverse',
    position === 'right' && 'flex-row ',
    position === 'left' && 'flex-row-reverse',
    props.className,
  );
  const tooltipClasssNames = twMerge(
    'absolute rounded hidden group-hover:flex  items-center',
    position === 'bottom' && 'top-full flex-col',
    position === 'top' && 'bottom-full flex-col-reverse',
    position === 'right' && 'left-full flex-row ',
    position === 'left' && 'right-full flex-row-reverse',
    props.tooltipClasssName,
  );

  const iconClassNames = twMerge(
    'text-gray600',
    position === 'bottom' && '-rotate-180',
    position === 'right' && 'rotate-90',
    position === 'left' && '-rotate-90',
    props.iconClassName,
  );

  const typographyClassNames = twMerge(
    'relative z-10 py-1 px-2 text-xs',
    'text-white bg-gray600 rounded-md',
    position === 'bottom' && 'bottom-1',
    position === 'top' && 'top-1',
    position === 'right' && 'right-1',
    position === 'left' && 'left-1',
    props.typographyClassName,
  );

  return (
    <div className={parentClassNames}>
      {children}
      <div className={tooltipClasssNames}>
        <Icon icon="caret-down" className={iconClassNames} size={12} />
        <Typography
          variant="body-small"
          as="p"
          className={typographyClassNames}
        >
          {content}
        </Typography>
      </div>
    </div>
  );
};

export default Tooltip;
